import React from 'react'
import HeaderThree from "../components/header/HeaderThree";
import BannerThree from "../components/banner/BannerThree";
import AboutThree from "../components/about/AboutThree";
import ServiceThree from "../components/service/ServiceThree";
import CallToActionTwo from "../components/calltoaction/CallToActionTwo";
import BusinessGoalTwo from "../components/businessgoal/BusinessGoalTwo";
import BusinessCaseTwo from "../components/businesscase/BusinessCaseTwo";
import CounterUpTwo from "../components/counterup/CounterUpTwo";
import FaqOne from "../components/faq/FaqOne";
import TeamTwo from "../components/team/TeamTwo";
import BrandThree from "../components/brand/BrandThree";
import PricingTwo from "../components/pricing/PricingTwo";
import ContactTwo from "../components/contactform/ContactTwo";
import BlogThree from "../components/blog/BlogThree";
import CallToActionThree from "../components/calltoaction/CallToActionThree";
import FooterThree from "../components/footer/FooterThree";


function HomeThree() {
    return (
        <div className='home-yellow'>

            <HeaderThree />
            <BannerThree />
            <AboutThree />
            <ServiceThree />
            <CallToActionTwo />
            <BusinessGoalTwo />
            <BusinessCaseTwo />
            <CounterUpTwo />
            <FaqOne />
            <TeamTwo />
            <BrandThree />
            <PricingTwo />
            <ContactTwo />
            <BlogThree />
            <CallToActionThree />
            <FooterThree />

        </div>
    )
}

export default HomeThree